import { panelRadius } from '../utils/globals'
import { useScale } from '../utils/scaleUtils'
import { SView, SViewProps } from './scaled'

export default function GlassPanel({
  borderColor,
  borderRadius,
  borderWidth,
  ...rest
}: SViewProps) {
  const scale = useScale()
  const styleProps = { borderColor, borderRadius, borderWidth }
  return <SView {...glassPanelStyle(scale, styleProps)} {...rest} />
}

export function glassPanelStyle(scale: number, styleProps?: SViewProps): SViewProps {
  const { borderColor, borderRadius = panelRadius, borderWidth = 1 } = styleProps ?? {}

  return {
    overflow: 'auto',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.06)',
    borderRadius,
    _before: {
      content: '""',
      position: 'absolute',
      inset: 0,
      padding: `${borderWidth * scale}px`,
      borderRadius: `${borderRadius * scale}px`,
      background:
        borderColor ||
        'linear-gradient(175deg, rgba(171, 171, 171, 1) 0%, rgba(64, 64, 64, .2) 15%, rgba(64, 64, 64, .2) 85%, rgba(163, 163, 163, 1) 100%)',
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      maskComposite: 'exclude',
      zIndex: -1,
    },
  }
}
